import type { InjectionKey } from 'vue';
import type { DriveService } from './types';

/** Provided by the Connect shell. Absent in standalone module builds. */
export const DriveServiceKey: InjectionKey<DriveService> = Symbol('DriveService');
